import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Container, ListGroup, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router'
import { ListGroupItem, getSvgIcon, getPartnerSupport , EMPTY_ARRAY, ListGroupItemPermit, EMPTY_OBJECT} from '../../../constants/globalConstants'
// import ProfileUser from '../../../assets/img/ic_profile_user.png'
// import edit from '../../../assets/img/edit.png'
import ConfirmationTerms from '../../../global/ConfirmationTerms'
import URL from '../../../constants/urls'
import { isPermissionExist, loggedInUserData, sortPortalPermissionByKey } from '../../../utils/helper'
import { handleUserLogOut } from '../../../redux/actions/singinAndSingUp'
import { getServicePage } from '../../../redux/actions/SevicesPage'
import { getConfigDetails } from '../../../services/config'
import CONSTANTS from '../../../redux/constants'
import { addEventLog } from '../../../redux/actions/EventsLog'
import { errorMessage } from '../../../constants/errorMessage'
require('./listItemForMenu.scss')

function ListItemForMenu(props) {
    const { dispatch, notify, isFetchingPartner, partnerDetails } = props
    const navigate = useNavigate()

    const partner = window.location.toString().split('/')[3]
    const [termsModalOpen, setTermsModalOpen] = useState(false)
    const [listItems, setListItems] = useState(EMPTY_ARRAY)

    useEffect(() => {
        // get partner by slug
        if(partner){
            // dispatch(getPartnerDetailsBySLug(partner)).then((res) => {
                if (partnerDetails?.email) {
                    localStorage.removeItem('partnerData')
                    localStorage.setItem('partnerData',JSON.stringify(partnerDetails))
                    const hasAccess = isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Main Menu'), 'Permit Purchase')
                    if(hasAccess){
                        setListItems(ListGroupItemPermit)
                    }else{
                        setListItems(ListGroupItem)
                    }
                    const partnerData = partnerDetails
                    const color = partnerData?.brand_setting?.color
                    const rgb = JSON.parse(partnerData?.brand_setting?.rgb_color)
                    if(color){
                        document.documentElement.style.setProperty('--bs-primary',color)
                        document.documentElement.style.setProperty('base-color',color)
                        document.documentElement.style.setProperty('primary',color)
                        document.documentElement.style.setProperty('textcolor',color)
                        document.documentElement.style.setProperty('--bs-btn-bg',color)
                        document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
                        document.documentElement.style.setProperty('--bs-list-group-active-border-color',color)
                        document.documentElement.style.setProperty('--bs-list-group-active-color',color)
                        document.documentElement.style.setProperty('--bs-list-group-active-bg',color)

                    }
                    
                } else {
                    localStorage.removeItem('partnerData')
                }
                
            // }).catch(() => {
            //     console.log('error')
                
            // })
        }
          
    }, [EMPTY_ARRAY, partnerDetails])


    const handleProfile = () => { navigate(`/${partner}/user-profile`) }

    const handleLogOut = () => {
        setTermsModalOpen(!termsModalOpen)
    }

    const handleClickListItem = (item) => {
        const pushBack = JSON.parse(localStorage.getItem('history'))

        if (item === 'Scan QR') { navigate(`/${partner}/${URL?.FACILITY_QR}`) }
        if (item === 'Vehicles') { navigate(`/${partner}/vehicle-list`) }
        if (item === 'Payments') { navigate(`/${partner}/payment-list`) }
        if (item === 'Receipts') { navigate(`/${partner}/${URL?.RECEIPTLIST}`) }
        if (item === 'Permit Purchase') { 
            const partnerSlug = partnerDetails?.partner_slug ? partnerDetails?.partner_slug : partner
                window.open(`${window?.location?.toString()?.includes('rev-pass') ? getConfigDetails()?.revportalURL : window?.location?.toString()?.includes('breeze') ? getConfigDetails()?.portalURLPCI : getConfigDetails()?.portalURL}/navigating/${loggedInUserData()?.access_token}/${loggedInUserData()?.refresh_token}/0/${pushBack?.facility}/${partnerSlug}`, '_self')
        }
    }

    const userLogOut = () => {
        const pushBack = JSON.parse(localStorage.getItem('history'))
        const getEmailUer = JSON.parse(localStorage.getItem('userEmail'))
        handleUserLogOut()
        localStorage.setItem('userEmail', JSON.stringify(getEmailUer !== '' ? getEmailUer : ''))
        if(pushBack?.route && pushBack?.facility){
            navigate(`/${partner}/${pushBack?.route}/${pushBack?.facility}`)
        }else{
            navigate(`/${partner}`)
        }
    }

    const handleBackClick = () => {
        const history = JSON.parse(localStorage.getItem('history'))
        if(history?.route && history?.facility){
            navigate(`/${partner}/${history?.route}/${history?.facility}`)
        }else{
            navigate(`/${partner}`)
        }
    }

    const handleServicesPages = (e, key) => {
        e.preventDefault()
        if (key === 'aboutUs') {
            navigate(`/${partner}/aboutUs`)
        } else if (key === 'termsCondition') {
            serviceDataApi('pave-term-condition', 'termCondition', 'Terms & Conditions')
        } else if (key === 'privacyPolicy') {
            serviceDataApi('pave-privacy-policy', 'privacyPolicy', 'Privacy Policy')
        } else if (key === 'FAQ') {
            serviceDataApi('pave-faq', 'faq', 'Frequently Asked Questions')
        }
    }

    const serviceDataApi = (urlSlug, secName, title) => {
        dispatch(getServicePage(urlSlug)).then((res) => {
            if (res?.data) {
                const data = { ...res?.data, 'sectioName': secName, 'title': title }
                navigate(`/${partner}/servicePage`, { state: data })
            } else {
                notify('error', res?.errors?.message)
            }
        }).catch((err) => {
            let errObject = { 
                payload: urlSlug,
                error: err,
                errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong  
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} serviceDataApi-listItemForMenu.js-114`))
            notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }

    return (
        isFetchingPartner ? null : <div style={{ overflow: 'hidden' }}>
            <Container className='mt-4'>
                <span><i className='fa fa-angle-left me-3 text-primary' onClick={() => handleBackClick()}></i><span className='d-inline-block' style={{ height: '25px', width: '25px' }}> {getSvgIcon('USER', 'var(--bs-primary)')}</span> <span className='d-inline me-2 ms-2 fw-semibold text-primary' style={{ height: '25px', width: '25px' }}> {loggedInUserData()?.user?.name} </span><span className='d-inline-block me-2 ms-2' style={{ height: '25px', width: '25px' }} onClick={handleProfile}>{getSvgIcon('Edit', 'var(--bs-primary)')}</span></span>
            </Container>
            <hr className='singHeaderBorder' />
            <ListGroup className="list-group-flush lh-1">
                {listItems?.map((item, index) =>
                    <>
                        {(item?.headingName !== 'Help Center') ?
                            <ListGroup.Item as="li" className="d-flex justify-content-between align-items-center" key={index} onClick={() => handleClickListItem(item?.headingName)}>
                                <span className='me-3' style={{ height: '25px', width: '25px' }}> {getSvgIcon(item?.headingName, 'var(--bs-primary)')}</span>
                                <div className="ms-2 me-auto"> <div >{item?.headingName}</div>
                                    <span className='header-m text-secondary'>{item?.subHeading}</span></div>
                                <span style={{ height: '25px', width: '25px' }}> {getSvgIcon('Right_Arrow', 'var(--bs-primary)')}</span>
                            </ListGroup.Item> :
                            <Accordion flush>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header className='mt-2'>
                                        <span className='text-primary floatIconCollapsed' style={{ height: '25px', width: '25px' }}>{getSvgIcon('downArrow', 'var(--bs-primary)')}</span>
                                        {/* <i  className='fa fa-angle-right'></i> */}
                                        <span className='me-3' style={{ height: '25px', width: '25px' }}> {getSvgIcon(item?.headingName, 'var(--bs-primary)')}</span>
                                        {/* <Image className='me-3' src={`data:image/svg+xml;utf8,${encodeURIComponent(getSvgIcon(item?.headingName))}`} width="25" height="25" /> */}
                                        <div className="ms-2 me-auto mb-2"> <div >{item?.headingName}</div>
                                            <span className='header-m text-secondary'>{item?.subHeading}</span></div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            {getPartnerSupport(partner)?.map((item, index) =>
                                                <Col key={index}>
                                                    <a className='text-decoration-none text-black' href={(item?.title === 'Call') ? partner == 'intrapark' ? 'tel:9547736466' : 'tel:4733378901' : (item?.title === 'Email') ? partner == 'intrapark' ? 'mailto:claims@intrapark.co' : 'mailto:someone@example.com' : null}>
                                                        <Card className='align-items-center p-2' onClick={(item?.title === 'FAQ') ? (e) => handleServicesPages(e, 'FAQ') : null}>
                                                            <span style={{ height: '23px', width: '23px' }}>{getSvgIcon(item?.title, 'var(--bs-primary)')}</span>
                                                            <br />
                                                            <small>{item?.title}</small>
                                                        </Card>
                                                    </a>
                                                </Col>
                                            )}
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        }
                    </>
                )}
            </ListGroup>
            <hr className='bottomBoarderFix' />
            {partner != 'intrapark' && <Container style={{ marginLeft: '0px' }}>
                <small className='listMenuTermsPolicy' onClick={(e) => handleServicesPages(e, 'aboutUs')}>About Us</small>
                <small className='listMenuTermsPolicy' onClick={partner == 'intrapark' ? null : (e) => handleServicesPages(e, 'termsCondition')}>Terms and Conditions</small>
                <small className='listMenuTermsPolicy' onClick={partner == 'intrapark' ? null : (e) => handleServicesPages(e, 'privacyPolicy')}>Privacy Policy</small>
            </Container>}
            <Button variant="light" className='ms-2 ps-1 mt-2 text-danger logoutListMenu' onClick={handleLogOut}>Logout</Button>
            <ConfirmationTerms isConfimationModalOpen={termsModalOpen} setIsConfimationModalOpen={setTermsModalOpen} handleLogout={userLogOut} Message='Are you sure you want to logout of your account?' cancelButton={true} cancelButtonLabel='Cancel' SubmitButton={true} SubmitButtonLable='Logout' />
        </div>
    )
}

ListItemForMenu.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
    isFetchingPartner: PropTypes.bool,
    partnerDetails: PropTypes.object,
}


ListItemForMenu.defaulProps = {
    dispatch: noop,
    loader: false,
    notify: noop,
    isFetchingPartner: true,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ singInAndSingUp, userDetailsReducer }) {
    return {
        loader: singInAndSingUp?.loader,
        isFetchingPartner: userDetailsReducer?.isFetching,
    }
}
export default connect(mapStateToProps)(ListItemForMenu)